var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.557,
    height: 10.558,
    viewBox: "0 0 10.557 10.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4f5b6d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.278,0a5.279,5.279,0,1,0,5.278,5.279A5.294,5.294,0,0,0,5.278,0Zm0,9.5A4.223,4.223,0,1,1,9.5,5.279,4.235,4.235,0,0,1,5.278,9.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M230.292,127.5H229.5v3.167l2.745,1.689.422-.686-2.375-1.425Z",
    transform: "translate(-224.749 -124.861)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleButton);
export default __webpack_public_path__ + "static/media/schedule-button.2aaff2a9ac7766010dc90bea898d8656.svg";
export { ForwardRef as ReactComponent };